<div class="ui-g ui-fluid search-toolbar-container">
  <p-accordion (onOpen)="onOpenToolbar()" (onClose)="onCloseToolbar()" *ngIf="!couponCategoryFilter">
    <p-accordionTab [selected]="isToolbarOpen">
      <p-header *ngIf="false">
        {{ 'toolbar.filters' | translate }}: {{ toolbarFilterSummary }}
      </p-header>

      <div class="ui-g-12 search-toolbar-box-container" style="padding-bottom: 0;">
        <!-- BOX PERIODO ANALISI -->
        <div class="ui-g-3 card card-w-title search-toolbar-box search-toolbar-box-analysis" style="border-right: #edf0f5 2px solid;">
          <div class="row ui-g-12">
            <i class="fa fw-user"></i>
            <span>{{ 'common.elapsed_analysis' | translate}}</span>
          </div>
          <div class="row ui-g-12">
            <div class="ui-g-12">{{ 'customerBase.startingDate' | translate}}</div>
            <div class="ui-g-12 search-toolbar-input">
              <p-dropdown [options]="elapsed_start_items" name="elapsed_start" [(ngModel)]="elapsed_start"
                          (onChange)="onLocalElapsedStartChange($event)"
                          placeholder="{{ 'customerBase.startingDate' | translate}}"
                          [disabled]="!this.dateBoxEnabled || !this.dateFromFieldEnabled" required>
              </p-dropdown>
            </div>
          </div>
          <div class="row ui-g-12">
            <div class="ui-g-12">{{ 'customerBase.endingDate' | translate}}</div>
            <div class="ui-g-12 search-toolbar-input">
              <p-dropdown [options]="elapsed_end_items" name="elapsed_end" [(ngModel)]="elapsed_end"
                          (onChange)="onLocalElapsedEndChange($event)"
                          placeholder="{{ 'customerBase.endingDate' | translate}}" [disabled]="!this.dateBoxEnabled" required>
              </p-dropdown>
            </div>
          </div>
        </div>
        <!-- BOX CLIENTI -->
        <div class="ui-g-3 card card-w-title search-toolbar-box search-toolbar-box-customer" style="border-right: #edf0f5 2px solid;">
          <div class="row ui-g-12">
            <i class="fa fw-user"></i>
            <span>{{ 'common.customers' | translate}}</span>
          </div>
          <div class="row ui-g-12">
            <div class="ui-g-12">{{ 'common.card' | translate}}</div>
            <div class="ui-g-12 search-toolbar-input">
              <p-dropdown [disabled]="!this.customersBoxEnabled || !this.cardModeFieldEnabled" [options]="card_mode_items" name="card_mode" [(ngModel)]="selected_card_mode"
                          (onChange)="onLocalCardModeChange($event)"></p-dropdown>
            </div>
          </div>
          <div class="row ui-g-12">
            <div class="ui-g-12">{{ 'customerBase.cluster' | translate}}</div>
            <div class="ui-g-12 search-toolbar-input">
              <p-multiSelect class="multiselect-container" [options]="cluster_items" name="selectedClusters" [(ngModel)]="selected_clusters"
                             [defaultLabel]="'common.select_something' | translate" styleClass="multiselect-fixed-height"
                             [disabled]="!this.customersBoxEnabled || !clusterFieldEnabled"></p-multiSelect>
            </div>
          </div>
        </div>
        <!-- BOX PUNTI VENDITA -->
        <div class="ui-g-6 card card-w-title search-toolbar-box search-toolbar-box-pos">
          <div class="row ui-g-12">
            <i class="fa fw-user"></i>
            <span>{{ 'common.stores' | translate}}</span>
          </div>

          <div class="row ui-g-6">
            <div class="ui-g-12">{{ 'common.group_type' | translate}}</div>
            <div class="ui-g-12 search-toolbar-input">
              <p-dropdown [options]="group_type_items" name="selected_group_type" [(ngModel)]="selected_group_type"
                          (onChange)="onLocalGroupTypeChange($event)"
                          [placeholder]="'common.select_something' | translate"
                          [disabled]="!this.storesBoxEnabled || !this.groupTypesFieldEnabled"></p-dropdown>
            </div>
          </div>

          <div class="row ui-g-6">
            <div class="ui-g-12">{{ 'common.areas' | translate}}</div>
            <div class="ui-g-12 search-toolbar-input">
              <p-dropdown [disabled]="!this.storesBoxEnabled || !this.areaFieldEnabled"
                          (onChange)="onLocalAreaChange($event)"
                          [options]="area_items" name="selected_area" [(ngModel)]="selected_area"></p-dropdown>
            </div>
          </div>

          <div class="row ui-g-6">
            <div class="ui-g-12">{{ 'common.group' | translate}}</div>
            <div class="ui-g-12 search-toolbar-input">
              <p-multiSelect class="multiselect-container" [options]="groups_items" name="selected_groups" [(ngModel)]="selected_groups"
                             (onChange)="onLocalGroupChange($event)"
                             [defaultLabel]="'common.select_something' | translate" styleClass="multiselect-fixed-height"
                             [disabled]="!this.storesBoxEnabled || !this.groupFieldEnabled"></p-multiSelect>
            </div>
          </div>

          <div class="row ui-g-6">
            <div class="ui-g-12">{{ 'common.stores' | translate}}</div>
            <div class="ui-g-12 search-toolbar-input">
              <p-multiSelect class="multiselect-container" [options]="store_items" name="selected_stores" [(ngModel)]="selected_stores"
                             (onChange)="onLocalStoreChange($event)"
                             [defaultLabel]="'common.select_something' | translate" styleClass="multiselect-fixed-height"
                             [disabled]="!this.storesBoxEnabled || !this.storeFieldEnabled"></p-multiSelect>
            </div>
          </div>

        </div>
      </div>

      <div class="ui-g-12 search-toolbar-row" style="padding-top: 0;">

        <div class="ui-g-12 card card-w-title search-toolbar-row-container" style="margin-top: 2px;" *ngIf="promoBoxEnabled || productsBoxEnabled">

          <!-- BOX PROMO -->
          <div class="row ui-g-12 search-toolbar-row-promos-title" *ngIf="promoBoxEnabled">
            <i class="fa fw-user"></i>
            <span>{{ 'common.promos' | translate}}</span>
          </div>
          <div class="row ui-g-12 search-toolbar-row-promos" *ngIf="promoBoxEnabled">
            <div class="ui-g-6">

              <p-dropdown [style]="{'width':'100%'}" [filter]="true" filterBy="label" [options]="this.promo_type_items" (onChange)="this.onPromoChange($event)"></p-dropdown>
            </div>
            <div class="ui-g-6">

              <p-dropdown [style]="{'width':'100%'}" [filter]="true" filterBy="label" [options]="this.promotion_items" (onChange)="this.selectedPromotion = $event.value"></p-dropdown>
            </div>
          </div>

          <!-- BOX PRODOTTI -->
          <div class="row ui-g-12 search-toolbar-row-products-title" *ngIf="productsBoxEnabled">
            <i class="fa fw-user"></i>
            <span>{{ 'common.products' | translate}}</span>
          </div>
          <div class="row ui-g-12 search-toolbar-row-products" *ngIf="productsBoxEnabled">
            <div class="ui-g-10">
              <p-chips [(ngModel)]="selected_sectors_items" (click)="displayProducts()" [disabled]="!this.productsBoxEnabled">
                <ng-template let-item pTemplate="item">
                  <span style="padding: 0.25em;">{{ item.label }}</span>
                </ng-template>
              </p-chips>
            </div>
            <div class="ui-g-2">
              <button [disabled]="this.selected_sectors_items.length <= 0" class="k-generic-btn" pButton type="button" (click)="resetProducts()" name="reset"
                      label="{{ 'common.reset' | translate }}" style="padding: 0;"></button>
            </div>
          </div>
        </div>
      </div>

      <div class="ui-g-12 search-toolbar-buttons">
        <div class="ui-g-9"></div>
        <div class="ui-g-3">
          <button class="k-generic-btn pull-right" pButton type="button" (click)="apply()" name="search" icon="fa fa-search"
                  label="{{ 'common.apply' | translate}}"></button>
        </div>
      </div>

      <div class="clearfix"></div>

    </p-accordionTab>
  </p-accordion>

  <!-- FILTRI CATEGORIE PER COUPON PRODOTTO NON FINANZIATO -->
  <div class="row ui-g-12 search-toolbar-row-products-title" *ngIf="couponCategoryFilter">
      <i class="fa fw-user"></i>
      <span>{{ 'common.products' | translate}}</span>
    </div>
    <div class="row ui-g-12 search-toolbar-row-products" *ngIf="couponCategoryFilter">
      <div class="ui-g-10">
        <p-chips [(ngModel)]="selected_sectors_items" (click)="displayProducts()" [disabled]="!this.couponCategoryFilter">
          <ng-template let-item pTemplate="item">
            <span style="padding: 0.25em;">{{ item.label }}</span>
          </ng-template>
        </p-chips>
      </div>
      <div class="ui-g-2">
        <button [disabled]="this.selected_sectors_items.length <= 0" class="k-generic-btn" pButton type="button" (click)="resetProducts()" name="reset"
                label="{{ 'common.reset' | translate }}" style="padding: 0;"></button>
      </div>
    </div>

</div>

<p-dialog
  *ngIf="showProductsDialog"
  [width]="600"
  [height]="800"
  [(visible)]="showProductsDialog"
  [header]="'common.select' | translate"
  [responsive]="true"
  [modal]="true"
>
  <div class="ui-g-12">
    <div class="row ui-g-12">
      <p-dropdown [style]="{'width':'100%'}" [filter]="true" filterBy="label" [options]="this.product_categories_items" (onChange)="this.onChangeCategory($event)"></p-dropdown>
    </div>
    <div class="row ui-g-12" style="height: 600px; overflow-y: scroll;">
      <p-treeTable (onNodeUnselect)="checkSelectedNode($event)"
                   selectionMode="multiple"
                   (onNodeSelect)="checkSelectedNode($event)"
                   *ngIf="this.selectedCategory != null"
                   [value]="this.product_subsectors"
                   [(selection)]="this.selectedSectors"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{'products.category_id' | translate}}</th>
            <th>{{'products.category_description' | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
          <tr [ttSelectableRow]="rowNode">
            <td>
              <p-treeTableToggler [rowNode]="rowNode"><i class="fa fa-caret-right"></i></p-treeTableToggler>
              {{ nicelyIdTreeView(rowData.id) }}
            </td>
            <td>{{rowData.description}}</td>
          </tr>
        </ng-template>

      </p-treeTable>
    </div>
    <div class="row ui-g-12">
      <button [disabled]="!checkNodesLevel" class="kvRoundedButton" pButton type="button" (click)="selectProducts()" name="search" icon="fa-search"
              label="{{ 'common.select' | translate}}"></button>
    </div>


  </div>

</p-dialog>



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/searchToolBar/search-toolbar.component.html